<template>
	<view>
		<form>
			<view class="cu-form-group margin-top">
				<view class="title">托盘码</view>
				<input v-model="code" placeholder="扫码 / 输入" name="input" @input="findCode" focus>
				<button v-model="matBtn" class="cu-btn bg-yellow" @click="toggle('right')"><text>+提取</text></button>
				
			</view>
		</form>
		<view class="margin-top">
			<uni-table border stripe emptyText="暂无更多数据">
				<uni-tr>
					<uni-th>数量</uni-th>
					<uni-th>产品代号</uni-th>
					<uni-th>产品名称</uni-th>
				</uni-tr>
				<uni-tr>
					<uni-td>1121</uni-td>
					<uni-td>1121</uni-td>
					<uni-td>1121</uni-td>
				</uni-tr>
			</uni-table>
			
		</view>
		<view>
			<button class="cu-btn bg-yellow pda-btn">组托</button>
			<button class="cu-btn bg-grey pda-btn" @click="reset">重置</button>
		</view>
		<view>
			<!-- 普通弹窗 -->
			<uni-popup ref="popup" background-color="#fff" style="width: 500rpx;">
				<view class="popup-content" :class="{ 'popup-height': type === 'left' || type === 'right' }">
						<view class="cu-form-group margin-top">
							<text>提取产品</text>
						</view>
						<view class="cu-form-group margin-top">
							<text class="title">产品ID</text>
							<input type="text" v-model="matNo" placeholder="扫码 / 输入" name="input" autocomplete="off" focus @input="find">
						</view>
						<view class="cu-form-group margin-top">
							<text class="title">产品名称</text>
							<input type="text" name="input" autocomplete="off" v-model="matName">
						</view>
						<view class="cu-form-group margin-top">
							<text class="title">规格型号</text>
							<input type="text" name="input" autocomplete="off" v-model="specs">
						</view>
						<view class="cu-form-group margin-top">
							<text class="title">单位</text>
							<input type="text" name="input" autocomplete="off" v-model="unit">
						</view>
						<view class="cu-form-group margin-top">
							<text class="title">数量</text>
							<uni-number-box @change="countDom" v-model="count" />
						</view>
						<button class="cu-btn bg-yellow pda-btn2" @click="confirm">提取</button>
						<view>
							<!-- 提示信息弹窗 -->
							<uni-popup ref="message" type="message">
								<uni-popup-message :type="msgType" :message="messageText" :duration="2000"></uni-popup-message>
							</uni-popup>
						</view>
				</view>
			</uni-popup>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				code:'',
				value: '',
				numberValue: 0,
				matBtn:'',
				matNo:'',
				matName:'',
				specs:'',
				unit:'',
				count:'0',
				matData:[],
				type: 'center',
				msgType: 'success',
				messageText: '这是一条成功提示',
				toPush:true,
				
			}
		},
		methods: {
			reset:function() {
				let that =this;
				that.code = '';
			},
			idid(){
				alert(1)
			},
			toggle(type) {
				this.type = type
				// open 方法传入参数 等同在 uni-popup 组件上绑定 type属性
				this.$refs.popup.open(type)
			},
			countDom(value) {
				
			},
			findCode(){ // 托盘码 超过8位
				let that = this;
				if(that.code.length === 8){
					that.toggle('right')
				}
			},
			// 根据产品代号查询产品详情
			find(){
				let that = this
				// if(isEmpty(that.matNo)){
				// 	return;
				// } isEmpty 未定义
				let thatId = that.matNo
				if(that.matNo.length===0){
					return;
				}
				uni.request({
					url:that.baseUrl+"/matCode/auth",
					header:{
						'content-type':'application/x-www-form-urlencoded',
						'token':localStorage.getItem('token'),	
					},
					data:{
						id:thatId
					},
					method:'POST',
					success:function(res){
						let data = res.data.data
						if(res.data.code === 200){
							if(data != null){
								that.matName = data.matName
								that.specs = data.specs
								that.unit = data.unit
							}
						} else if (res.data.code ===403 ){
							// 待定
						} else {
							// 待定
						}
					}
					
				})
			},
			// 提取
			confirm(){
				let that = this
				let data = {
					matNo:that.matNo,
					matName:that.matName,
					count:that.count
				}
				
				that.addTbaleData(data)
				
			},
			addTbaleData(data){
				if(data.matName===''){
					this.messageToggle('error')
					return
				}
				
				this.$refs.popup.close()
				for(var i=0;i<this.matData.length;i++){
					console.log(data)
					console.log(this.data)
					if(data.matNo === this.matData[i].matNo){
						this.matData[i].count = Number(this.matData[i].count) + Number(data.count);
							this.toPush  = false;
					}
				}
				if(this.toPush){
					this.matData.push(data)
				}
				this.messageToggle('success')
				
			},
			
			messageToggle(type) {
				this.msgType = type
				this.messageText = `提取失败`
				this.$refs.message.open()
			},
			
		}
	}
</script>

<style>
	.pda-btn2{
		display: flex;
		margin-left: 100rpx;
		margin-top: 150rpx;
		width: 200rpx;
		height: 80rpx;
	}
	.popup-content {
		align-items: center;
		justify-content: center;
		padding: 15px;
		width: 80vw;
		height: 50px;
		background-color: #fff;
	}
</style>
